const initScroll = () => {
    const offset = -40;
    let scrollPosition = 0;
    let ticking = false;

    document.addEventListener('scroll', () => {
        if (!ticking) {
            // Request animation frame method for perf,
            // as per: https://developer.mozilla.org/en-US/docs/Web/API/Document/scroll_event#scroll_event_throttling
            window.requestAnimationFrame(() => {
                // Only check if scrolled down offset amount
                if ((document.body.getBoundingClientRect()).top < offset) {
                    // Check current scroll position against previous iteration
                    if ((document.body.getBoundingClientRect()).top > scrollPosition) {
                        document.body.setAttribute('data-scroll-direction', 'up');
                    } else {
                        document.body.setAttribute('data-scroll-direction', 'down');
                    }
                    document.body.setAttribute('data-scrolled', 'true');
                } else {
                    document.body.setAttribute('data-scroll-direction', 'top');
                    document.body.setAttribute('data-scrolled', 'false');
                }

                // saves the new position for iteration.
                scrollPosition = document.body.getBoundingClientRect().top;

                // set ticking var to false
                ticking = false;
            });

            ticking = true;
        }
    });
};

export { initScroll as default };
